const FACEBOOK = 'facebook';
const TWITTER = 'twitter';
const EMAIL = 'email';
const GOOGLE = 'google';
const MICROSOFT = 'microsoft';

export { FACEBOOK, TWITTER, EMAIL, GOOGLE, MICROSOFT };
